var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-show-more"},[_c('div',{staticClass:"button"},[_c('a',{staticClass:"btn btn-full btn-show-more",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.template.cta))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }